import { takePreviewTracks } from '../../WaitingRoom/preview-tracks';

import { showErrorToast } from '@amigoapp/doca-react';
import { useRoomContext, usePersistentUserChoices } from '@livekit/components-react';
import { ConnectionState, RoomEvent, Track } from 'livekit-client';
import { useEffect, useRef, useState } from 'react';

const usePublishLocalTracks = () => {
	const room = useRoomContext();
	const { userChoices } = usePersistentUserChoices();

	const previewTracksRef = useRef(null);
	const publishingRef = useRef(false);
	const [previewVideoTrack, setPreviewVideoTrack] = useState(null);

	useEffect(() => {
		if (previewTracksRef.current === null) {
			previewTracksRef.current = takePreviewTracks();

			setPreviewVideoTrack(previewTracksRef.current.find(track => track.kind === Track.Kind.Video) || null);
		}

		const publish = async () => {
			const { localParticipant } = room;

			const published = localParticipant.getTrackPublication(Track.Source.Microphone)
				|| localParticipant.getTrackPublication(Track.Source.Camera);

			if (published || publishingRef.current) {
				return;
			}

			publishingRef.current = true;

			const tracks = previewTracksRef.current;
			const hasPreviewOf = kind => tracks.some(track => track.kind === kind);

			try {
				await Promise.all([
					...tracks.map(track => localParticipant.publishTrack(track)),
					hasPreviewOf(Track.Kind.Video) ? null : localParticipant.setCameraEnabled(userChoices.videoEnabled),
					hasPreviewOf(Track.Kind.Audio) ? null : localParticipant.setMicrophoneEnabled(userChoices.audioEnabled)
				].filter(Boolean));
			} catch (error) {
				publishingRef.current = false;

				showErrorToast('Não foi possível ativar a câmera e o microfone.');
			}
		};

		room.on(RoomEvent.SignalConnected, publish);
		room.on(RoomEvent.Connected, publish);

		if (room.state === ConnectionState.Connected) {
			publish();
		}

		return () => {
			room.off(RoomEvent.SignalConnected, publish);
			room.off(RoomEvent.Connected, publish);
		};
	}, [room, userChoices.videoEnabled, userChoices.audioEnabled]);

	return previewVideoTrack;
};

export default usePublishLocalTracks;
